// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator billing`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import companies from 'modules/core/store/collections/companies'
import features from 'modules/core/store/collections/features'
import legalEntities from 'modules/core/store/collections/legalEntities'

import subscriptions from 'modules/billing/store/collections/subscriptions'
import employees from 'modules/employees/store/collections/employees'
import locations from 'modules/locations/store/collections/locations'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [companies, {}] /* Referenced by 2 cases in this module */,
    [employees, {}] /* Referenced by 2 cases in this module */,
    [features, {}] /* Referenced by 1 cases in this module */,
    [legalEntities, {}] /* Referenced by 46 cases in this module */,
    [locations, {}] /* Referenced by 32 cases in this module */,
    [subscriptions, {}] /* Referenced by 23 cases in this module */,
  ] /* Generated file 👉 artifacts/billing-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
